import { FC, useState } from 'react';
import { MATERIAL_ICON_SEARCH } from '../common/Input';
import ModalDialog from '../components/modal/ModalDialog';
import LoadingSpinner from '../components/LoadingSpinner';
import { Button, ButtonSize, ButtonTheme } from '../common/Button';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
    readonly users: any;
    readonly loading?: boolean;
    readonly show?: boolean;
    readonly findUsers: (query?: string) => void;
    readonly onImpersonate: (user: any) => void;
    readonly onClose: () => void;
};

const ImpersonationDialog: FC<Props> = ({
    findUsers = () => {},
    loading = false,
    users = [],
    onImpersonate = () => {},
    show = false,
    onClose = () => {}
}) => {
    const { t } = useTranslation();
    const [userName, setUserName] = useState('');
    function searchUsers() {
        findUsers(userName);
    }

    return (
        <ModalDialog show={show} title={t('components.impersonation.title')} onCloseButtonClick={onClose}>
            <p className="txt-normal" style={styles.textHint}>
                {t('components.impersonation.subtitle')}
                <br />
                <span className="cold-grey">
                    <Trans
                        i18nKey="components.impersonation.description"
                        components={{
                            br: <br />
                        }}
                    />
                </span>
            </p>
            <p className="txt-normal">
                <input
                    onChange={event => setUserName(event.target.value)}
                    value={userName}
                    placeholder={t('components.impersonation.searchPlaceholder')}
                    style={styles.searchInput}
                />
                <Button
                    text={t('components.impersonation.searchButtonLabel')}
                    icon={MATERIAL_ICON_SEARCH}
                    onClick={searchUsers}
                    size={ButtonSize.MEDIUM}
                    theme={ButtonTheme.NEUTRAL}
                />
            </p>
            {loading ? (
                <LoadingSpinner width={50} />
            ) : (
                <ul style={styles.userList}>
                    {users.map(user => {
                        return (
                            <li key={user.id}>
                                <a onClick={() => onImpersonate(user)}>
                                    <i className="material-icons">face</i>&nbsp;
                                    {user.username}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            )}
        </ModalDialog>
    );
};

const styles = {
    userList: {
        maxHeight: '400px',
        overflow: 'auto',
        fontSize: '14px',
        lineHeight: '24px'
    },
    searchInput: {
        width: '80%',
        borderBottom: '1px solid lightgray',
        marginRight: '10px'
    },
    textHint: {
        lineHeight: '20px'
    }
};
export default ImpersonationDialog;
